/** @jsxImportSource theme-ui */
import { Box, Heading } from 'theme-ui';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import qs from 'qs';
import { Column } from '@component-controls/components';
import { useGetDiscountAgreementsQuery, useLazyGetDiscountAgreementsQuery } from '@/store/apiService';
import DataTable from '@/components/DataTable';
import { Container } from '@/components/styled';
import { DiscountAgreementStatusEnum } from '@/types/types';


type Props = {
    actions?: Column;
};

export const tableColumns = [
    {
        columnKey: 'id',
        Header: 'id',
        accessor: 'Id',
        width: '100px',
    },
    {
        columnKey: 'name',
        Header: 'Name',
        accessor: 'Name',
    },
    {
        columnKey: 'description',
        Header: 'Description',
        accessor: 'Description',
        width: '200px',
        Cell: ({ cell }) => {
            if (cell?.value?.split('\n')?.length > 0) {
                return (
                    <>
                        {cell.value.split('\n').map((line) => (
                            <Box>{line}</Box>
                        ))}
                    </>
                );
            }

            return <>{cell.value}</>;
        },
    },
    {
        columnKey: 'status',
        Header: 'Status',
        accessor: 'Status',
        width: '100px',
    },

    {
        columnKey: 'validFrom',
        Header: 'Valid from',
        accessor: 'ValidFrom',
        Cell: ({ cell }) => format(new Date(cell.value), 'd MMM yyyy, p'),
    },
];

const DiscountAgreements = ({ actions }: Props) => {

    const [searchParams] = useSearchParams();
    const [getDiscountAgreements, discountAgreementsState] = useLazyGetDiscountAgreementsQuery();
    const discountAgreements = discountAgreementsState.data ? discountAgreementsState.data : [];

    useEffect(() => {
        const params = qs.parse(searchParams.toString());
        getDiscountAgreements(params);

        if (Object.keys(params).length === 0) {
            discountAgreementsState.reset();
        }
    }, [searchParams.toString()]);


    return (
        <Container>
            <Heading>Discount agreements</Heading>
            <DataTable
                data={discountAgreements}
                columns={[...tableColumns, actions]}
                isLoading={discountAgreementsState.isLoading}
                isFetching={discountAgreementsState.isFetching}
            />
        </Container>
    );
};

export default DiscountAgreements;
